export enum CookieAge {
  ONE_YEAR = 365 * 24 * 60 * 60,
  ONE_MONTH = 30 * 24 * 60 * 60,
  ONE_WEEK = 7 * 24 * 60 * 60,
  ONE_DAY = 24 * 60 * 60,
  ONE_HOUR = 60 * 60,
  ONE_MINUTE = 60,
}
